export default function LeaguesStatus(leagueData) {
  console.log("leagueData", leagueData.data.status);
  return (
    <div className={`status-badge ${leagueData.data.status.toLowerCase()}`}>
      {leagueData.data.status}
    </div>
  );
}
